import React, { createContext, useMemo } from 'react';

interface SuggesterResultsContextProps {
    researchSuggesterResultsNumber?: number | null;
    companySuggesterResultsNumber?: number | null;
}

export const SuggesterResultsContext = createContext<SuggesterResultsContextProps>({} as SuggesterResultsContextProps);

export function SuggesterResultsContextProvider({
    children,
    researchSuggesterResultsNumber,
    companySuggesterResultsNumber,
}: {
    children: React.ReactNode;
} & SuggesterResultsContextProps) {
    const memorizedChildren = useMemo(() => children, [children]);

    return (
        <SuggesterResultsContext.Provider
            value={{
                researchSuggesterResultsNumber,
                companySuggesterResultsNumber,
            }}>
            {memorizedChildren}
        </SuggesterResultsContext.Provider>
    );
}
